<template>
  <div class="overflow-y-hidden">

    <router-view v-if='templateId' :key='templateId' />

    <apollo-query v-else :query='getTemplatesQuery'
      :variables='{from, size}'
      fetch-policy='cache-and-network'
      class="grid grid-cols-2 md:grid-cols-6 gap-2 overflow-y-auto">
      <template v-slot='{ result: { loading, error, data }, isLoading }'>
        <pbc-button class="flex-none self-center" @click='createTemplate'>
          New
        </pbc-button>

        <button v-for='template in (((data||{}).getTemplates||{}).items||[])'
            :key='template.id'
            @click='onTemplate(template)'
            class='p-4 rounded m-4 shadow text-center border border-white flex flex-col justify-between'>

          <div class="flex flex-col justify-center grow">
            <img :src='makeImageUrl(template)' class="object-contain w-full py-3" />
          </div>

          <div class="text-gray-300 font-semibold text-xs">{{template.title}}</div>

        </button>
      </template>
    </apollo-query>
  </div>
</template>
<script>
const EMPTY = JSON.stringify({ "game": { "bgcolor": "#313131", "cols": 0, "rows": 0 }, "id": "root", "name": "Empty", "description": "I just created a new game", "toybox": [], "features": [], "variables": [], "components": [], "links": [], "scenes": [ { "name": "Scene 1", "variables": [], "transforms": [ { "id": "a4a011df-415a-4e5d-84e5-854e23ad3cfb", "cid": "e724acdf-8b0c-4120-a7fe-31b9f2d8b1c8", "children": [], "transform": { "pos": { "x": 0, "y": 0 }, "scale": { "x": 1, "y": 1 }, "rotation": 0, "localScale": { "x": 1, "y": 1 }, "localRotation": 0 }, "color": 16711680 } ], "components": [ { "type": "camera", "id": "e724acdf-8b0c-4120-a7fe-31b9f2d8b1c8", "aspect": "9x16", "active": true, "depth": 0, "parent": null, "isPrefab": false, "numChildren": 0, "closed": false, "name": "", "description": "", "expose": false, "disabled": false } ], "links": [] } ], "image": "2c7f2179-968c-4dc1-bd46-6241a3f16cba.png", "revision": 0, "owner": "c8943c94-7880-4d22-814b-937fece19328", "lastChanged": "c8943c94-7880-4d22-814b-937fece19328", "disableWebgl": false, "uistates": { "win": { "layout": [], "classes": [] }, "lose": { "layout": [], "classes": [] }, "playing": { "layout": [], "classes": [] } }, "systems": [], "themes": [], "saved": 1581340932704 });

import gql from 'graphql-tag';
const uploadTemplateMutation = gql(`
mutation uploadTemplate($id: String!, $title: String!, $thumbnailImage: String!, $labels: String!, $data: String!) {
  uploadTemplate(id: $id, title: $title, thumbnailImage: $thumbnailImage,
                    labels: $labels, data: $data) {
    id
  }
}
`);

import { getTemplatesQuery } from '@/gql/Queries.js';
export default {
  inject: ['api'],
  data() {
    return {
      getTemplatesQuery,
      from: 0,
      size: 100
    }
  },
  methods: {
    async createTemplate() {
      const id = window.prompt("id");

      const title = 'new template';
      const thumbnailImage = 'placeholder.png';
      const labels = '';
      const data = JSON.parse(EMPTY);
      data.id = id;
      data.template = {
        version:1,
        source:'pbc',
        components:[]
      }
      await this.$apollo.mutate({
        mutation: uploadTemplateMutation,
        variables: {
          id,
          title,
          labels,
          thumbnailImage,
          data:JSON.stringify(data)
        }
      });
    },
    makeImageUrl(template) {
      return this.api.makeImageUrlEditor(template.thumbnailImage);
    },
    onTemplate(template) {
      this.$router.push({
        name:'editTemplate',
        params: {
          templateId: template.id
        }
      });
    }
  },
  computed: {
    templateId() {
      return this.$route.params.templateId;
    }
  }
}
</script>
